export const CANDIDATE = '/candidate';
